import { UserRole } from '@common/clients/api';
import { AdminIcon } from '@common/svg/icons/components/AdminIcon';
import { EditorIcon } from '@common/svg/icons/components/EditorIcon';
import { ModeratorIcon } from '@common/svg/icons/components/ModeratorIcon';

const getAuthorIcon = (role: UserRole): React.ReactElement | null => {
    switch (role) {
        case UserRole.MODERATOR:
            return <ModeratorIcon />;
        case UserRole.EDITOR:
            return <EditorIcon />;
        case UserRole.ADMIN:
            return <AdminIcon />;
        default:
            return null;
    }
};

interface Props {
    role: UserRole;
}

export const UserRoleIcon = ({ role }: Props) => getAuthorIcon(role);
